import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// GROUPED GALLERY DATA
const galleryGroups = {
  Graham: [
        {
      image: "/images/about.png",
      title: "Premium Homes",
      location: "Burma Hills, Accra",
    },
            {
      image: "/images/apartment.png",
      title: "Premium Homes",
      location: "Burma Hills, Accra",
    },
                {
      image: "/images/apartment1.jpeg",
      title: "Premium Homes",
      location: "Burma Hills, Accra",
    },
                    {
      image: "/images/apartment2.jpeg",
      title: "Premium Homes",
      location: "Burma Hills, Accra",
    },
    {
      image: "/images/graham1.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham2.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham3.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham4.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham5.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham6.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham7.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham8.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham9.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham10.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/graham11.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham12.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham13.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham14.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham15.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham16.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham17.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/graham18.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/graham19.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/graham20.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/graham21.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/graham22.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
    //         {
    //   image: "/images/graham23.jpg",
    //   title: "The Graham",
    //   location: "Tse Addo, Accra",
    // },
            {
      image: "/images/graham24.jpg",
      title: "The Graham",
      location: "Tse Addo, Accra",
    },
  ],
  Smart_Houses: [
    {
      image: "/images/solo2.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/solo3.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/solo4.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
    {
      image: "/images/solo5.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo6.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo7.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo8.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo9.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo10.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo11.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo12.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo13.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo14.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo15.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo16.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo17.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
        {
      image: "/images/solo18.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/solo19.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/solo20.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/solo21.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
            {
      image: "/images/solo22.jpg",
      title: "Smart Homes",
      location: "Tse Addo, Accra",
    },
  ],
  // Commercial: [
  //   {
  //     image: "/images/gallery6.jpg",
  //     title: "Commercial Office Space",
  //     location: "Osu, Accra",
  //   },
  // ],
  // Apartments: [
  //   {
  //     image: "/images/gallery4.jpg",
  //     title: "Ocean View Condo",
  //     location: "Labadi, Accra",
  //   },
  //   {
  //     image: "/images/gallery9.jpg",
  //     title: "Beachfront Property",
  //     location: "Ada Foah, Ghana",
  //   },
  // ],
};

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Flattened list for modal navigation
  const allItems = Object.values(galleryGroups).flat();

  // Open modal
  const openModal = (globalIndex) => {
    setSelectedIndex(globalIndex);
    document.body.style.overflow = "hidden";
  };

  // Close modal
  const closeModal = () => {
    setSelectedIndex(null);
    document.body.style.overflow = "auto";
  };

  // Navigate images
  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % allItems.length);
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? allItems.length - 1 : prev - 1
    );
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* HEADER SECTION */}
      <div className="relative w-full h-[60vh] flex items-center justify-center">
        <img
          src="/images/header.jpg"
          alt="Gallery Header"
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black/50"></div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-4"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Our Gallery
          </h1>
          <p className="text-gray-200 mt-4 text-lg md:text-xl max-w-2xl mx-auto">
            Explore our stunning collection of properties and completed projects.
          </p>
        </motion.div>
      </div>

      {/* GALLERY SECTIONS */}
      <div className="max-w-7xl mx-auto px-6 py-16 space-y-16">
        {Object.entries(galleryGroups).map(([group, items]) => (
          <div key={group}>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              {group}
            </h2>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
            >
              {items.map((item, index) => {
                const globalIndex = allItems.findIndex(
                  (i) => i.image === item.image && i.title === item.title
                );

                return (
                  <motion.div
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                    className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                    onClick={() => openModal(globalIndex)}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-72 object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col items-center justify-center text-center p-4">
                      <h3 className="text-white text-xl font-semibold mb-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-200 text-sm">{item.location}</p>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
          </div>
        ))}
      </div>

      {/* LIGHTBOX MODAL */}
      <AnimatePresence>
        {selectedIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 z-50 flex flex-col items-center justify-center px-4"
          >
            <button
              onClick={closeModal}
              className="absolute top-6 right-6 text-white text-3xl hover:text-gray-300"
            >
              ✕
            </button>
            <button
              onClick={prevImage}
              className="absolute left-4 md:left-12 top-1/2 transform -translate-y-1/2 text-white text-4xl hover:text-gray-300"
            >
              ←
            </button>
            <button
              onClick={nextImage}
              className="absolute right-4 md:right-12 top-1/2 transform -translate-y-1/2 text-white text-4xl hover:text-gray-300"
            >
              →
            </button>

            {/* IMAGE PREVIEW */}
            <motion.img
              key={selectedIndex}
              src={allItems[selectedIndex].image}
              alt={allItems[selectedIndex].title}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="max-h-[80vh] max-w-full rounded-lg shadow-xl"
            />

            {/* PROPERTY TITLE & LOCATION */}
            <div className="text-center mt-4">
              <h2 className="text-white text-xl font-semibold">
                {allItems[selectedIndex].title}
              </h2>
              <p className="text-gray-300 text-sm">
                {allItems[selectedIndex].location}
              </p>
            </div>

            <p className="text-gray-300 mt-2 text-lg">
              {selectedIndex + 1} / {allItems.length}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
